import { render, staticRenderFns } from "./ServiceTypesList.vue?vue&type=template&id=fe7dfd56&scoped=true"
import script from "./ServiceTypesList.vue?vue&type=script&lang=js"
export * from "./ServiceTypesList.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypesList.vue?vue&type=style&index=0&id=fe7dfd56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7dfd56",
  null
  
)

export default component.exports